import { mapActions } from 'pinia/dist/pinia';
import { useControlLayerStore } from '@/store-pinia/control-layer';

export default {
  props: {
    activeElement: {
      type: Object,
      required: true
    }
  },
  computed: {
    /**
     * This should be used over the `activeElement` prop, so we can potentially
     * use this in the future when editing multiple elements
     *
     * There is one exception, when passing down the active element (or elements
     * in the future) the prop should be used.
     * ```
     *   <some-component
     *      :active-element="activeElement"
     *      @event="update(element)
     *      >
     * ```
     *
     * @returns {Object}
     */
    element() {
      return this.activeElement;
    }
  },
  methods: {
    updateElement(changeset) {
      this.updateActiveElements([
        {
          uid: this.activeElement.uid,
          changeset
        }
      ]);
    },
    ...mapActions(useControlLayerStore, {
      updateActiveElements: 'updateElements'
    })
  }
};
